module.exports = __webpack_public_path__ + "static/TaskGovernance-b79a8670760a55020dd0ce25c1ac359a.jpg";